import React from 'react';
import getJobEventTracker from './getJobEventTracker';
import LinkAndAnchor from '../components/LinkAndAnchor';
import { getLocalizedCategoryParameterByCategory } from './jobCategories';
import messages from './messages.mjs';

const relatedToTitle = (job, intl, locale, client) => {
  const { title } = job;
  const titleEventTracker = getJobEventTracker(
    client,
    'Meteor Job archived search by title',
    job,
  );

  return [
    <LinkAndAnchor
      route={`jobs.${locale}`}
      params={{ keywords: title }}
      title={title}
      onClick={titleEventTracker}
      useRouter
    >
      {intl.formatMessage(
        messages['jobs.relatedTo'], { term: title },
      )}
    </LinkAndAnchor>,
  ];
};

const relatedCompanies = (job, intl, locale, client) => {
  const { profiles, company } = job;
  const companyNameTracker = getJobEventTracker(
    client,
    'Meteor Job archived search by company',
    job,
  );

  const companySearchTermTracker = getJobEventTracker(
    client,
    'Meteor Job archived search by company name',
    job,
  );

  return (profiles.length === 0
    ? [
      <LinkAndAnchor
        route={`jobs.${locale}`}
        params={{ keywords: company.displayName }}
        title={company.displayName}
        onClick={companyNameTracker}
        useRouter
      >
        {intl.formatMessage(
          messages['jobs.relatedTo'], { term: company.displayName },
        )}
      </LinkAndAnchor>,
    ]
    : profiles.map((profile) => (
      <LinkAndAnchor
        route={`jobs.${locale}`}
        params={{ companySlug: profile.page.slug }}
        title={profile.page.title}
        onClick={companySearchTermTracker}
        useRouter
      >
        {intl.formatMessage(
          messages['jobs.relatedTo'], { term: profile.page.title },
        )}
      </LinkAndAnchor>
    )));
};

const relatedCities = (job, intl, locale, client) => {
  const { cities, city } = job;
  const cityTracker = getJobEventTracker(
    client, 'Meteor Job archived search by city', job,
  );

  return (cities.length === 0
    ? [
      <LinkAndAnchor
        route={`jobs.onlyLocationSearch.${locale}`}
        params={{ locationSearch: city }}
        title={city}
        onClick={cityTracker}
        useRouter
      >
        {intl.formatMessage(messages['jobs.city.title'], { city })}
      </LinkAndAnchor>,
    ]
    : cities.map((cityItem) => (
      <LinkAndAnchor
        route={`jobs.${locale}`}
        params={{ citySlug: cityItem.slug }}
        title={cityItem.name}
        onClick={cityTracker}
        useRouter
      >
        {intl.formatMessage(
          messages['jobs.city.title'], { city: cityItem.name },
        )}
      </LinkAndAnchor>
    )));
};

const relatedCategories = (job, intl, locale, client) => {
  const { categories } = job;

  const categoryTracker = getJobEventTracker(
    client, 'Meteor Job archived search by category', job,
  );

  return (
    categories.map((category) => (
      <LinkAndAnchor
        route={`jobs.${locale}`}
        params={{
          categoryParam:
            getLocalizedCategoryParameterByCategory(intl, category),
        }}
        title={category}
        onClick={categoryTracker}
        useRouter
      >
        {intl.formatMessage(
          messages['jobs.position.title'], { position: category },
        )}
      </LinkAndAnchor>
    ))
  );
};

const getRelatedJobSearches = (job, intl, locale, client) => [
  ...relatedToTitle(job, intl, locale, client),
  ...relatedCompanies(job, intl, locale, client),
  ...relatedCities(job, intl, locale, client),
  ...relatedCategories(job, intl, locale, client),
];

export default getRelatedJobSearches;
